var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group tw-block"},[(_vm.label)?_c('BaseInputLabel',{attrs:{"for":_vm.labelFor,"required-field":_vm.required}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._t("default"),(_vm.hasError)?_c('BaseInputError',{staticClass:"tw-mt-1"},[_vm._v(" "+_vm._s(_vm.inputError)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }